import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-quill/dist/quill.snow.css';
import 'prismjs/prism';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-jsx';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import 'src/assets/css/common.scss';
import 'src/assets/css/tailwind.css';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { enableES5 } from 'immer';
import { init } from '@amplitude/analytics-browser';
import store from 'src/redux';
import App from 'src/App';
import * as Sentry from '@sentry/react';

import { isProd, AMPLITUDE_API_KEY } from './config/index';
import 'core-js';
enableES5();

Sentry.init({
  dsn: 'https://647c43612f174c45809affb629368033@o358256.ingest.sentry.io/5683208',
  environment: isProd ? 'production' : 'development'
});

init(AMPLITUDE_API_KEY);

createRoot(document.getElementById('root')).render(
  <Sentry.ErrorBoundary fallback={'An error has occurred'}>
    <Provider store={store}>
      <App />
    </Provider>
  </Sentry.ErrorBoundary>
);
